module.exports = __webpack_public_path__ + "img/FIA.141cb4c.jpg";